import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, Transition as _Transition, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "text-lg font-bold text-gray-400 border-b pb-2" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "w-12/12" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", { class: "mb-2 text-sm flex justify-between" }, "Inventory Source:", -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "py-1" }
const _hoisted_9 = {
  href: "#",
  class: "text-gray-700 block px-4 py-2 text-sm w-full border-t"
}
const _hoisted_10 = { class: "flex flex-row mt-5 gap-x-2" }
const _hoisted_11 = { class: "flex-1" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "whitespace-nowrap font-bold text-sm" }, "Miniumim Sell Price", -1)
const _hoisted_13 = { class: "border border-gray-400 rounded flex" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "flex-1 text-center" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, "¢", -1)
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { class: "flex-1" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "whitespace-nowrap font-bold text-sm" }, "# of Rounds", -1)
const _hoisted_21 = { class: "border border-gray-400 rounded flex" }
const _hoisted_22 = { class: "flex-1 text-center" }
const _hoisted_23 = { class: "flex flex-row text-sm" }
const _hoisted_24 = { class: "flex-1" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { for: "candidates" }, "Skip Confirmation", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", null, "Read the Rules", -1)
const _hoisted_27 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChevronDownIcon = _resolveComponent("ChevronDownIcon")!
  const _component_MenuButton = _resolveComponent("MenuButton")!
  const _component_MenuItem = _resolveComponent("MenuItem")!
  const _component_MenuItems = _resolveComponent("MenuItems")!
  const _component_Menu = _resolveComponent("Menu")!
  const _directive_autowidth = _resolveDirective("autowidth")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.roundsAvailable > 0)
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          onSubmit: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _createElementVNode("h3", _hoisted_2, [
            _createTextVNode(" Submit a Sell Order "),
            (_ctx.priceIsLocked)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, " at " + _toDisplayString(_ctx.milliCents) + "¢", 1))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_Menu, {
            as: "div",
            class: "relative w-full inline-block text-left mt-4"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createVNode(_component_MenuButton, { class: "inline-flex justify-between w-full border border-gray-400 rounded shadow-sm px-4 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-gray-400" }, {
                  default: _withCtx(() => [
                    (_ctx.productId)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.productId), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_7, "Select Product")),
                    _createVNode(_component_ChevronDownIcon, {
                      class: "-mr-1 ml-2 h-5 w-5",
                      "aria-hidden": "true"
                    })
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_Transition, {
                "enter-active-class": "transition ease-out duration-100",
                "enter-from-class": "transform opacity-0 scale-95",
                "enter-to-class": "transform opacity-100 scale-100",
                "leave-active-class": "transition ease-in duration-75",
                "leave-from-class": "transform opacity-100 scale-100",
                "leave-to-class": "transform opacity-0 scale-95"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_MenuItems, { class: "origin-top-left absolute left-0 mt-2 w-full rounded-md shadow-lg bg-white ring-1 ring-black focus:outline-none" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_8, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inventoryHoldings, (record) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: record.id,
                            class: ""
                          }, [
                            (record.rounds > 0 && _ctx.commodityId == record.commodityId )
                              ? (_openBlock(), _createBlock(_component_MenuItem, {
                                  key: 0,
                                  onClick: ($event: any) => (_ctx.selectProduct(record))
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("a", _hoisted_9, [
                                      _createElementVNode("h1", null, _toDisplayString(record.productId) + " (" + _toDisplayString(record.rounds) + " rounds)", 1)
                                    ])
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", {
                  disabled: _ctx.priceIsLocked,
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.decrCent && _ctx.decrCent(...args))),
                  class: "inline-block cursor-pointer bg-slate-100 p-3 text-indigo-500 hover:bg-indigo-200 rounded-l"
                }, " -1¢ ", 8, _hoisted_14),
                _createElementVNode("div", _hoisted_15, [
                  _withDirectives(_createElementVNode("input", {
                    disabled: _ctx.priceIsLocked,
                    class: "inline border-0 text-right w-16 p-0 my-3 focus:outline-none focus:border-none",
                    type: "text",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.milliCents) = $event))
                  }, null, 8, _hoisted_16), [
                    [_directive_autowidth, { minWidth: `${_ctx.milliCents.toString().length * 10}px`, }],
                    [_vModelText, _ctx.milliCents]
                  ]),
                  _hoisted_17
                ]),
                _createElementVNode("div", {
                  disabled: _ctx.priceIsLocked,
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.incrCent && _ctx.incrCent(...args))),
                  class: "inline-block cursor-pointer bg-slate-100 p-3 text-indigo-500 hover:bg-indigo-200 rounded-r"
                }, " +1¢ ", 8, _hoisted_18)
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", {
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.decrBox && _ctx.decrBox(...args))),
                  class: "inline-block cursor-pointer bg-slate-100 p-3 text-indigo-500 hover:bg-indigo-200 rounded-l"
                }, " -20 "),
                _createElementVNode("div", _hoisted_22, [
                  _withDirectives(_createElementVNode("input", {
                    class: "inline border-0 text-right w-16 p-0 my-3 focus:outline-none focus:border-none",
                    type: "text",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.rounds) = $event))
                  }, null, 512), [
                    [_directive_autowidth, { minWidth: `${_ctx.rounds.toString().length * 10}px` }],
                    [_vModelText, _ctx.rounds]
                  ])
                ]),
                _createElementVNode("div", {
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.incrBox && _ctx.incrBox(...args))),
                  class: "inline-block cursor-pointer bg-slate-100 p-3 text-indigo-500 hover:bg-indigo-200 rounded-r"
                }, " +20 ")
              ])
            ])
          ]),
          _createElementVNode("button", {
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.submitOrder())),
            class: "my-3 w-full text-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          }, _toDisplayString(_ctx.skipConfirmation ? "Submit Order" : "Next"), 1),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _withDirectives(_createElementVNode("input", {
                id: "candidates",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.skipConfirmation) = $event)),
                name: "candidates",
                type: "checkbox",
                class: "h-4 w-4 mr-2 text-indigo-600 border-gray-300 rounded"
              }, null, 512), [
                [_vModelCheckbox, _ctx.skipConfirmation]
              ]),
              _hoisted_25
            ]),
            _hoisted_26
          ])
        ], 32))
      : (_openBlock(), _createElementBlock("div", _hoisted_27, "You have no inventory to sell."))
  ]))
}